import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4eb9068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-wrapper-mask" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  key: "expanded",
  class: "logo-wrapper-mask_image",
  src: "https://dam.malt.com/navbar/malt-logo-red.svg?vh=9690b2",
  width: "125",
  height: "35",
  alt: "Malt logo"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import {useAsideMenu, useDisplayMode} from '@/logged/features';
    import {useDisplayMobile} from '@/logged/common/composables';
    import {storeToRefs} from 'pinia';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoWrapper',
  setup(__props) {

    const asideMenuStore = useAsideMenu();
    const displayModeStore = useDisplayMode();
    const {isDisplayModeReduced} = storeToRefs(displayModeStore);

    const {isDisplayMobile} = useDisplayMobile();

    function handleCloseMobileNavBar() {
        asideMenuStore.setMobileNavBarOpened(false);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["logo-wrapper flex", {isReduced: _unref(isDisplayModeReduced), isMobile: _unref(isDisplayMobile)}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: _unref(asideMenuStore).logoNavigationRoute
      }, _hoisted_4, 8, _hoisted_2)
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: handleCloseMobileNavBar
    }, [
      (_unref(isDisplayMobile))
        ? (_openBlock(), _createBlock(_component_joy_icon, {
            key: 0,
            name: "cross",
            size: "small",
            color: "grey"
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})